"use client"

import { type Locale } from "@/i18n/routing"
import { zodResolver } from "@hookform/resolvers/zod"
import { NextIntlClientProvider, type AbstractIntlMessages } from "next-intl"
import { FormProvider as ReactHookFormProvider, useForm } from "react-hook-form"

import { Stepper } from "@/components/ui/stepper"
import {
  FormSchemaVideoGameGenerator,
  type FormValuesVideoGame,
} from "@/components/generators/videogamesnamen/VideoGameNameGeneratorSchema"

type ProviderProps = {
  children: React.ReactNode
  locale: Locale
  intlMessages: Pick<AbstractIntlMessages, "Generator">
}

export function GamingNameGeneratorProviders({
  children,
  locale,
  intlMessages,
}: ProviderProps) {

  const methods = useForm<FormValuesVideoGame>({
    resolver: zodResolver(FormSchemaVideoGameGenerator),
    defaultValues: {
      buchstabe: "random",
      sprache: "english",
      geschlecht: "masculine",
      klang: "gamer",
      silben: "one",
    },
  })

  return (
    <NextIntlClientProvider
      messages={intlMessages}
      locale={locale}
      timeZone="Europe/Berlin"
    >
      <ReactHookFormProvider {...methods}>
        <Stepper defaultValue="info">{children}</Stepper>
      </ReactHookFormProvider>
    </NextIntlClientProvider>
  )
}
